import React, { useState } from 'react';
import {
  ChevronDown, Menu, X, Code, Smartphone, Globe, Cog, Users, TrendingUp, Shield, Zap, ArrowRight,
  CheckCircle, Play, Target, Layers, ShieldCheck, Globe2, Award
} from 'lucide-react';
import Header from "./header";
import Footer from "./footer";
export default function PaymentGatewayStaffAugmentation() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [formData, setFormData] = useState({
    fullName: '',
    phoneNumber: '',
    email: '',
    companyName: '',
    message: ''
  });

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert('Consultation request submitted! Our payment gateway specialists will contact you soon.');
    setFormData({
      fullName: '',
      phoneNumber: '',
      email: '',
      companyName: '',
      message: ''
    });
  };

  return (
    <div className="min-h-screen bg-white">
      <style jsx>{`
        @keyframes fadeInLeft {
          from {
            opacity: 0;
            transform: translateX(-50px);
          }
          to {
            opacity: 1;
            transform: translateX(0);
          }
        }
        
        @keyframes fadeInRight {
          from {
            opacity: 0;
            transform: translateX(50px);
          }
          to {
            opacity: 1;
            transform: translateX(0);
          }
        }
        
        @keyframes spinSlow {
          from {
            transform: rotate(0deg);
          }
          to {
            transform: rotate(360deg);
          }
        }
        
        .animate-fade-in-left {
          animation: fadeInLeft 0.8s ease-out forwards;
        }
        
        .animate-fade-in-right {
          animation: fadeInRight 0.8s ease-out forwards;
        }
        
        .animate-spin-slow {
          animation: spinSlow 8s linear infinite;
        }
      `}</style>
      {/* Header */}
      <Header />
      {/* Hero Section - Light */}
      <section className="bg-gradient-to-br from-blue-50 via-indigo-50 to-cyan-50 py-20 relative overflow-hidden">
        <div className="absolute top-10 right-10 w-20 h-20 bg-blue-200 rounded-full opacity-50 animate-pulse"></div>
        <div className="absolute bottom-20 left-10 w-16 h-16 bg-indigo-200 rounded-full opacity-60 animate-bounce"></div>
        <div className="absolute top-1/2 right-1/4 w-12 h-12 bg-cyan-200 rounded-full opacity-40 animate-pulse"></div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <div className="inline-flex items-center px-4 py-2 bg-blue-100 rounded-full text-blue-700 text-sm font-medium mb-6">
                <Award className="h-4 w-4 mr-2" />
                Flexible Engagement for Every Business
              </div>
              <h1 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6 leading-tight">
                Engagement <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-indigo-600">
                  Model
                </span>

              </h1>

              <p className="text-xl text-gray-600 mb-8 leading-relaxed">
                From licensing to managed services, transaction-based to revenue-share models,
                we provide flexible engagement options tailored to banks, merchants,
                and enterprises. Scale securely and cost-effectively with models that match
                your business goals.
              </p>

              <div className="flex items-center space-x-6 text-sm text-gray-600">
                <div className="flex items-center">
                  <CheckCircle className="h-5 w-5 text-green-500 mr-2" />
                  License & On-Premise Deployment
                </div>
                <div className="flex items-center">
                  <CheckCircle className="h-5 w-5 text-green-500 mr-2" />
                  Managed Services & SaaS
                </div>
                <div className="flex items-center">
                  <CheckCircle className="h-5 w-5 text-green-500 mr-2" />
                  Transaction-Based & Revenue Sharing
                </div>
              </div>
            </div>

            <div className="relative">
              <div className="bg-white rounded-3xl shadow-2xl p-8 transform hover:scale-105 transition-transform duration-300">
                <div className="mb-6">
                  <video
                    className="w-full h-64 rounded-2xl object-cover"
                    autoPlay
                    muted
                    loop
                    src="/fintechV.mp4"
                  >
                    Your browser does not support the video tag.
                  </video>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>



      {/* Service Models Section - Light */}
      <section className="py-16 bg-gradient-to-br from-gray-50 to-blue-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">


          {/* BOT Section */}
          <section className="py-16 px-6">
            <div className="max-w-6xl mx-auto">
              <div className="grid md:grid-cols-2 gap-10 items-center">
                <div className="animate-fade-in-left">
                  <h2 className="text-3xl font-bold text-gray-900 mb-4">
                    Build-Operate-Transfer (BOT)
                  </h2>
                  <p className="text-base text-gray-600 mb-4">
                    A proven model to establish secure, compliant, and scalable
                    payment operations with reduced risk. We handle setup, operations,
                    and talent while ensuring a clear transition to client ownership.
                  </p>
                  <p className="text-base text-gray-600">
                    Best suited for organizations seeking quick market entry with
                    long-term control and value creation.
                  </p>
                </div>
                <div className="flex justify-center animate-fade-in-right">
                  <div className="relative group">
                    <div className="w-64 h-64 bg-gradient-to-br from-teal-400 to-blue-500 rounded-full flex items-center justify-center transition-transform duration-300 group-hover:scale-105">
                      <div className="w-48 h-48 bg-white rounded-full flex items-center justify-center">
                        <Cog className="w-24 h-24 text-teal-500 animate-spin-slow" />
                      </div>
                    </div>
                    <div className="absolute -top-2 -right-2 w-6 h-6 bg-yellow-400 rounded-full animate-bounce"></div>
                    <div className="absolute -bottom-2 -left-2 w-4 h-4 bg-pink-400 rounded-full animate-pulse"></div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* POD Section */}
          <section className="py-16 px-6 bg-gray-50">
            <div className="max-w-6xl mx-auto">
              <div className="grid md:grid-cols-2 gap-10 items-center">
                <div className="md:order-2 animate-fade-in-right">
                  <h2 className="text-3xl font-bold text-gray-900 mb-4">POD Teams</h2>
                  <p className="text-base text-gray-600 mb-4">
                    Agile POD-based delivery model for specialized functions such as
                    payment integration, security, or compliance. Each POD is
                    self-contained and outcome-driven.
                  </p>
                  <p className="text-base text-gray-600">
                    Enables faster delivery, deeper functional expertise, and improved
                    alignment with business objectives.
                  </p>
                </div>
                <div className="md:order-1 flex justify-center animate-fade-in-left">
                  <div className="relative group">
                    <div className="w-64 h-64 bg-gradient-to-br from-green-400 to-teal-500 rounded-full flex items-center justify-center transition-transform duration-300 group-hover:scale-105">
                      <div className="w-48 h-48 bg-white rounded-full flex items-center justify-center">
                        <Target className="w-24 h-24 text-green-500 animate-pulse" />
                      </div>
                    </div>
                    <div
                      className="absolute -top-2 -left-2 w-6 h-6 bg-purple-400 rounded-full animate-bounce"
                      style={{ animationDelay: "0.5s" }}
                    ></div>
                    <div
                      className="absolute -bottom-2 -right-2 w-4 h-4 bg-orange-400 rounded-full animate-pulse"
                      style={{ animationDelay: "1s" }}
                    ></div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* CaaS Section */}
          <section className="py-16 px-6">
            <div className="max-w-6xl mx-auto">
              <div className="grid md:grid-cols-2 gap-10 items-center">
                <div className="animate-fade-in-left">
                  <h2 className="text-3xl font-bold text-gray-900 mb-4">
                    Captive-as-a-Service (CaaS)
                  </h2>
                  <p className="text-base text-gray-600 mb-4">
                    Experience the benefits of a dedicated captive unit without
                    operational overhead. We establish, operate, and optimize captive
                    delivery centers on your behalf.
                  </p>
                  <p className="text-base text-gray-600">
                    Ideal for organizations seeking speed to scale, cost efficiency,
                    and full-service operational agility.
                  </p>
                </div>
                <div className="flex justify-center animate-fade-in-right">
                  <div className="relative group">
                    <div className="w-64 h-64 bg-gradient-to-br from-blue-400 to-purple-500 rounded-full flex items-center justify-center transition-transform duration-300 group-hover:scale-105">
                      <div className="w-48 h-48 bg-white rounded-full flex items-center justify-center">
                        <Globe className="w-24 h-24 text-blue-500 animate-spin-slow" />
                      </div>
                    </div>
                    <div
                      className="absolute -top-2 -right-2 w-6 h-6 bg-green-400 rounded-full animate-bounce"
                      style={{ animationDelay: "0.3s" }}
                    ></div>
                    <div
                      className="absolute -bottom-2 -left-2 w-4 h-4 bg-red-400 rounded-full animate-pulse"
                      style={{ animationDelay: "0.8s" }}
                    ></div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* GCC Section */}
          <div className="max-w-6xl mx-auto">
            <div className="grid md:grid-cols-2 gap-10 items-center">
              <div className="md:order-2 animate-fade-in-right">
                <h2 className="text-3xl font-bold text-gray-900 mb-4">
                  Global Capability Centers (GCC)
                </h2>
                <p className="text-base text-gray-600 mb-4">
                  Establish GCCs as strategic innovation hubs rather than cost
                  centers. Drive payment product development, compliance operations,
                  and digital transformation globally.
                </p>
                <p className="text-base text-gray-600">
                  Our GCC model enables cross-border collaboration, operational
                  excellence, and sustainable competitive advantage.
                </p>
              </div>
              <div className="md:order-1 flex justify-center animate-fade-in-left">
                <div className="relative group">
                  <div className="w-64 h-64 bg-gradient-to-br from-purple-400 to-pink-500 rounded-full flex items-center justify-center transition-transform duration-300 group-hover:scale-105">
                    <div className="w-48 h-48 bg-white rounded-full flex items-center justify-center">
                      <Users className="w-24 h-24 text-purple-500 animate-pulse" />
                    </div>
                  </div>
                  <div
                    className="absolute -top-2 -left-2 w-6 h-6 bg-blue-400 rounded-full animate-bounce"
                    style={{ animationDelay: "0.7s" }}
                  ></div>
                  <div
                    className="absolute -bottom-2 -right-2 w-4 h-4 bg-yellow-400 rounded-full animate-pulse"
                    style={{ animationDelay: "1.2s" }}
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>


      {/* Stats Section - Dark */}
      <section className="py-16 bg-gray-900">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-2 lg:grid-cols-5 gap-8 text-center">
            <div className="group hover:transform hover:scale-105 transition-all duration-200">
              <div className="text-4xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-indigo-400 mb-2">24h</div>
              <div className="text-gray-300 text-sm">Expert Deployment Time</div>
            </div>
            <div className="group hover:transform hover:scale-105 transition-all duration-200">
              <div className="text-4xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-indigo-400 mb-2">150+</div>
              <div className="text-gray-300 text-sm">Professionals</div>
            </div>
            <div className="group hover:transform hover:scale-105 transition-all duration-200">
              <div className="text-4xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-indigo-400 mb-2">99.9%</div>
              <div className="text-gray-300 text-sm">Bank Grade Security Compliance</div>
            </div>
            <div className="group hover:transform hover:scale-105 transition-all duration-200">
              <div className="text-4xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-indigo-400 mb-2">60%</div>
              <div className="text-gray-300 text-sm">Faster Time-to-Market</div>
            </div>
            <div className="group hover:transform hover:scale-105 transition-all duration-200">
              <div className="text-4xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-indigo-400 mb-2">24/7</div>
              <div className="text-gray-300 text-sm">Security Monitoring</div>
            </div>
          </div>
        </div>
      </section>

      {/* Solutions Section - Light */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Our Approach
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Beyond delivery models, enhanced value proposition with security,
              flexibility, and global scalability at the core.
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            {/* Flexibility */}
            <div className="bg-gradient-to-br from-blue-50 to-indigo-50 rounded-2xl p-8 hover:shadow-lg transition-shadow">
              <div className="bg-gradient-to-r from-blue-500 to-indigo-500 w-16 h-16 rounded-2xl flex items-center justify-center mb-6">
                <Layers className="w-8 h-8 text-white" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">Flexible Engagement</h3>
              <p className="text-gray-600">
                Start small or scale big — our models adapt to your project’s
                complexity, timelines, and evolving requirements.
              </p>
            </div>

            {/* Security First */}
            <div className="bg-gradient-to-br from-green-50 to-emerald-50 rounded-2xl p-8 hover:shadow-lg transition-shadow">
              <div className="bg-gradient-to-r from-green-500 to-emerald-500 w-16 h-16 rounded-2xl flex items-center justify-center mb-6">
                <ShieldCheck className="w-8 h-8 text-white" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">Security First</h3>
              <p className="text-gray-600">
                Every engagement is built on PCI-compliant, bank-grade security
                practices to keep your payments safe and reliable.
              </p>
            </div>

            {/* Global Scale */}
            <div className="bg-gradient-to-br from-purple-50 to-pink-50 rounded-2xl p-8 hover:shadow-lg transition-shadow">
              <div className="bg-gradient-to-r from-purple-500 to-pink-500 w-16 h-16 rounded-2xl flex items-center justify-center mb-6">
                <Globe2 className="w-8 h-8 text-white" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">Global Delivery</h3>
              <p className="text-gray-600">
                Access top talent and delivery capabilities across regions,
                ensuring round-the-clock execution and faster outcomes.
              </p>
            </div>
          </div>
        </div>
      </section>


      <section className="py-8 bg-gradient-to-br from-blue-600 via-indigo-600 to-purple-700 relative overflow-hidden">
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          <div className="absolute top-10 left-10 w-32 h-32 bg-white/10 rounded-full animate-pulse"></div>
          <div className="absolute top-40 right-20 w-24 h-24 bg-white/5 rounded-lg animate-bounce transform rotate-45" style={{ animationDelay: '1s' }}></div>
          <div className="absolute bottom-20 left-20 w-16 h-16 bg-white/10 rounded-full animate-pulse" style={{ animationDelay: '2s' }}></div>
          <div className="absolute bottom-40 right-10 w-20 h-20 bg-white/5 rounded-lg animate-bounce transform -rotate-12" style={{ animationDelay: '0.5s' }}></div>

          <div className="absolute top-1/4 left-1/4 animate-float">
            <Zap className="w-8 h-8 text-white/20" />
          </div>
          <div className="absolute top-1/3 right-1/3 animate-float" style={{ animationDelay: '1.5s' }}>
            <Shield className="w-6 h-6 text-white/20" />
          </div>
          <div className="absolute bottom-1/3 left-1/3 animate-float" style={{ animationDelay: '3s' }}>
            <TrendingUp className="w-7 h-7 text-white/20" />
          </div>
        </div>

        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center">
          {/* Main Content */}


          <div className="space-y-4 animate-fadeInUp">
            <h2 className="text-2xl sm:text-3xl lg:text-3xl font-bold text-white leading-tight animate-slideInLeft">
              The Right Engagement Model to Scale Your Business.
            </h2>
          </div>

          {/* CTA Button - Smaller and More Compact */}
          <div className="mt-6 animate-fadeInUp" style={{ animationDelay: '1.2s' }}>
            <button
              className="group relative inline-flex items-center gap-3 bg-gradient-to-r from-white to-blue-50 text-blue-700 px-8 py-3 rounded-xl font-semibold text-lg hover:from-yellow-300 hover:to-orange-300 hover:text-gray-900 transform hover:scale-105 transition-all duration-500 shadow-xl hover:shadow-yellow-300/50"
              onClick={() => {
                window.location.href = '/contact';
              }}
            >
              <Play className="w-5 h-5 group-hover:animate-bounce" />
              <span>Get In Touch</span>
              <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform duration-300" />

              {/* Button Glow Effect */}
              <div className="absolute inset-0 bg-gradient-to-r from-white/20 to-transparent rounded-xl opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
            </button>
          </div>
        </div>

        <style jsx>{`
                  @keyframes float {
                    0%, 100% { transform: translateY(0px) rotate(0deg); }
                    33% { transform: translateY(-10px) rotate(5deg); }
                    66% { transform: translateY(5px) rotate(-5deg); }
                  }
                  
                  @keyframes fadeInUp {
                    from { opacity: 0; transform: translateY(30px); }
                    to { opacity: 1; transform: translateY(0); }
                  }
                  
                  @keyframes slideInLeft {
                    from { opacity: 0; transform: translateX(-50px); }
                    to { opacity: 1; transform: translateX(0); }
                  }
                  
                  @keyframes slideInRight {
                    from { opacity: 0; transform: translateX(50px); }
                    to { opacity: 1; transform: translateX(0); }
                  }
                  
                  @keyframes slideInUp {
                    from { opacity: 0; transform: translateY(40px); }
                    to { opacity: 1; transform: translateY(0); }
                  }
                  
                  .animate-float {
                    animation: float 4s ease-in-out infinite;
                  }
                  
                  .animate-fadeInUp {
                    animation: fadeInUp 0.8s ease-out forwards;
                    opacity: 0;
                  }
                  
                  .animate-slideInLeft {
                    animation: slideInLeft 0.8s ease-out forwards;
                    opacity: 0;
                  }
                  
                  .animate-slideInRight {
                    animation: slideInRight 0.8s ease-out forwards;
                    opacity: 0;
                  }
                  
                  .animate-slideInUp {
                    animation: slideInUp 0.8s ease-out forwards;
                    opacity: 0;
                  }
                `}</style>
      </section>

      <Footer />
    </div>
  );
} 
